import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const cmsService = {
  // ==================== HERO ====================
  async getHero() {
    const response = await axios.get(`${API_URL}/api/cms/hero`);
    return response.data;
  },

  async updateHero(data) {
    const response = await axios.put(`${API_URL}/api/cms/hero`, data);
    return response.data;
  },

  // ==================== BENEFITS ====================
  async getBenefits() {
    const response = await axios.get(`${API_URL}/api/cms/benefits`);
    return response.data;
  },

  async updateBenefits(benefits) {
    const response = await axios.put(`${API_URL}/api/cms/benefits`, benefits);
    return response.data;
  },

  // ==================== PROCESS ====================
  async getProcess() {
    const response = await axios.get(`${API_URL}/api/cms/process`);
    return response.data;
  },

  async updateProcess(steps) {
    const response = await axios.put(`${API_URL}/api/cms/process`, steps);
    return response.data;
  },

  // ==================== FAQ ====================
  async getFAQ() {
    const response = await axios.get(`${API_URL}/api/cms/faq`);
    return response.data;
  },

  async updateFAQ(faqs) {
    const response = await axios.put(`${API_URL}/api/cms/faq`, faqs);
    return response.data;
  },

  // ==================== CONTACT ====================
  async getContact() {
    const response = await axios.get(`${API_URL}/api/cms/contact`);
    return response.data;
  },

  async updateContact(data) {
    const response = await axios.put(`${API_URL}/api/cms/contact`, data);
    return response.data;
  },
};
